document.addEventListener("DOMContentLoaded", function () {
  function initMobileImageSlider() {
    if (window.innerWidth <= 768) {
      if (!$('.images-mobile-slider').hasClass('slick-initialized')) {
        $('.images-mobile-slider').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
          autoplay: true,
          autoplaySpeed: 3000,
          infinite: true,
          speed: 800,
        });
      }
    } else {
      if ($('.images-mobile-slider').hasClass('slick-initialized')) {
        $('.images-mobile-slider').slick('unslick');
      }
    }
  }

  initMobileImageSlider();

  window.addEventListener('resize', function () {
    initMobileImageSlider();
  });
});


document.addEventListener("DOMContentLoaded", function () {
  function initBlackImageSlider() {
    if (window.innerWidth <= 768) {
      if (!$('.black-image-slider').hasClass('slick-initialized')) {
        $('.black-image-slider').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
          autoplay: true,
          infinite: true,
          speed: 800,
        });
      }
    } else {
      if ($('.black-image-slider').hasClass('slick-initialized')) {
        $('.black-image-slider').slick('unslick');
      }
    }
  }

  initBlackImageSlider();
  window.addEventListener('resize', initBlackImageSlider);
});




document.addEventListener("DOMContentLoaded", function () {
  let realGamersSwiper;
  let originalSliderHTML = null;

  function initRealGamersSwiper() {
    if (typeof Swiper === "undefined") return;

    const sliderContainer = document.querySelector(".real-gamers-slider-container");
    if (!sliderContainer) return;

    // Save original HTML if not saved
    if (!originalSliderHTML) {
      originalSliderHTML = sliderContainer.innerHTML;
    }

    // MOBILE VIEW
    if (window.innerWidth <= 768) {
      // If already has Swiper, do nothing
      if (realGamersSwiper) return;

      // Clear container and create new mobile structure
      sliderContainer.innerHTML = '';
      
      const mobileSlider = document.createElement('div');
      mobileSlider.className = 'real-gamers-slider swiper';
      mobileSlider.id = 'mobile-real-gamers-slider';
      
      const wrapper = document.createElement('div');
      wrapper.className = 'swiper-wrapper';
      
      // Get image blocks from original HTML
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = originalSliderHTML;
      const imageBlocks = tempDiv.querySelectorAll('.image-block');
      
      imageBlocks.forEach(block => {
        const slide = document.createElement('div');
        slide.className = 'swiper-slide';
        slide.appendChild(block.cloneNode(true));
        wrapper.appendChild(slide);
      });
      
      mobileSlider.appendChild(wrapper);
      
      const pagination = document.createElement('div');
      pagination.className = 'swiper-pagination';
      mobileSlider.appendChild(pagination);
      
      sliderContainer.appendChild(mobileSlider);

      // Initialize Swiper
      realGamersSwiper = new Swiper('#mobile-real-gamers-slider', {
        slidesPerView: 1,
        spaceBetween: 10,
        loop: true,
        speed: 800,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      });

    } 
    // DESKTOP VIEW
    else {
      // Destroy Swiper if exists
      if (realGamersSwiper) {
        realGamersSwiper.destroy(true, true);
        realGamersSwiper = null;
      }
      
      // Restore original HTML structure
      sliderContainer.innerHTML = originalSliderHTML;
    }
  }

  // Initialize on load
  initRealGamersSwiper();
  
  // Throttle resize event
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initRealGamersSwiper, 150);
  });
});



